import { useState } from 'react';

import { useAppSelector } from 'app';
import {
  BoxColorIcon,
  FarmerColorIcon,
  PeopleLinkColorIcon,
  ShopColorIcon,
  TruckColorIcon,
  UserColorIcon,
  VolunteerColorIcon,
} from 'components/Icon';
import { selectAppDevice } from 'slice';
import { COLLABORATOR_TEXT, DEVICES } from 'utils';

import MenuSelectionDesktop from './MenuSelectionDesktop';
import MenuSelectionMobile from './MenuSelectionMobile';

interface MenuSelectionProps {
  entityType: string;
  searchValue: string;
  setEntityType: (e: string) => void;
  handleChangeSearchValue: (e: string) => void;
}

const MenuSelection = ({
  entityType,
  searchValue,
  setEntityType,
  handleChangeSearchValue,
}: MenuSelectionProps): JSX.Element => {
  const [selected, setSelected] = useState('all');
  const appDevice = useAppSelector(selectAppDevice);

  const handleChangeSelected = (e: string) => {
    setSelected(e);
  };

  const selectItems = [
    {
      action: () => setEntityType('all'),
      icon: <UserColorIcon height={18} width={18} />,
      name: 'Tất cả tài khoản',
      entityType: 'all',
    },
    {
      action: () => setEntityType('farm'),
      icon: <FarmerColorIcon height={18} width={18} />,
      name: 'Tài khoản nông trại',
      entityType: 'farm',
    },
    {
      action: () => setEntityType('store'),
      icon: <ShopColorIcon height={18} width={18} />,
      name: 'Tài khoản cửa hàng',
      entityType: 'store',
    },
    {
      action: () => setEntityType('transport'),
      icon: <TruckColorIcon height={18} width={18} />,
      name: 'Tài khoản vận chuyển',
      entityType: 'transport',
    },
    {
      action: () => setEntityType('warehouse'),
      icon: <BoxColorIcon height={18} width={18} />,
      name: 'Tài khoản kho chứa',
      entityType: 'warehouse',
    },
    {
      action: () => setEntityType('collaborator'),
      icon: <PeopleLinkColorIcon height={18} width={18} />,
      name: `Tài khoản ${COLLABORATOR_TEXT.LOWERCASE}`,
      entityType: 'collaborator',
    },
    {
      action: () => setEntityType('volunteer'),
      icon: <VolunteerColorIcon height={18} width={18} />,
      name: 'Tài khoản thiện nguyện',
      entityType: 'volunteer',
    },
  ];

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <MenuSelectionDesktop
        handleChangeSearchValue={handleChangeSearchValue}
        handleChangeSelected={handleChangeSelected}
        selectItems={selectItems}
        selected={selected}
      />
    ),
    [DEVICES.MOBILE]: (
      <MenuSelectionMobile
        entityType={entityType}
        handleChangeSearchValue={handleChangeSearchValue}
        handleChangeSelected={handleChangeSelected}
        searchValue={searchValue}
        selectItems={selectItems}
        selected={selected}
      />
    ),
    [DEVICES.TABLET]: (
      <MenuSelectionMobile
        entityType={entityType}
        handleChangeSearchValue={handleChangeSearchValue}
        handleChangeSelected={handleChangeSelected}
        searchValue={searchValue}
        selectItems={selectItems}
        selected={selected}
      />
    ),
  };

  return renderElements[appDevice.device];
};

export default MenuSelection;
